// Ссылки на юрпакет B2C для подвала, «Контактов», «Оплаты» и «Возврата».
// Реквизиты оператора — в @osmix/lib/operator (их же выводит шлюз в HTML без JS).
export { OPERATOR, operatorLine } from "@osmix/lib/operator";

// PDF лежат в public/docs/b2c (см. src/index.ts); имена кириллические с пробелами.
const doc = (file: string) => `/docs/b2c/${encodeURIComponent(file)}`;

export const LEGAL_DOCS = {
	offer: doc("Пользовательское соглашение OSMIX.pdf"),
	returns: doc("Правила возврата и обмена товаров OSMIX.pdf"),
	delivery: doc("Правила доставки и примерки OSMIX.pdf"),
	legalEntityPayment: doc("Правила оплаты юридическими лицами OSMIX.pdf"),
	privacy: doc("Политика конфиденциальности OSMIX.pdf"),
	pdnPolicy: doc("Политика обработки персональных данных OSMIX.pdf"),
	pdnConsent: doc("Согласие на обработку персональных данных.pdf"),
	cookie: doc("Политика использования cookie OSMIX.pdf"),
} as const;
